import { captureExceptionEvent, constructQueryString } from "shared-services";
import { constructQueryStringValues } from "shared-services/src/helpers/query-string";

import { IAuthParams } from "../services/user-account-service.types";

export type RequestOptions = {
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  headers?: HeadersInit | undefined;
  body?: any;
  authParams?: IAuthParams;
  redirect?: RequestRedirect;
};

export const constructAuthPath = <T extends Record<string, any> = IAuthParams>(
  currentPath: string,
  authParams: T
) => {
  const containsQueryString = currentPath.includes("?");
  let authQueryString = "";

  if (containsQueryString) {
    authQueryString = `&${constructQueryStringValues(authParams)}`;
  } else {
    authQueryString = constructQueryString(authParams);
  }

  return `${currentPath}${authQueryString}`;
};

export const fetchRequest = async (path: string, options?: RequestOptions) => {
  const updatedOptions = {
    method: options?.method || "GET",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      ...options?.headers,
    },
    body: JSON.stringify(options?.body),
    redirect: options?.redirect,
  };

  let url = path;

  if (options?.authParams) {
    url = constructAuthPath(path, options.authParams);
  }

  const response = await fetch(url, updatedOptions);

  if (!response.ok) {
    const responseinJSON = await response.json();
    const isErrorAnObject = typeof responseinJSON === "object";

    const errorObject = isErrorAnObject
      ? Error(responseinJSON.title, { cause: { ...responseinJSON } })
      : Error(responseinJSON);

    captureExceptionEvent(errorObject, {
      methodName: path,
    });

    throw errorObject;
  }

  return response;
};
